import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { InfoIcon } from '@phosphor-icons/react/Info';

type DspRestrictionTooltipProps = {
  tooltipTextLines: string[];
};

export const DspRestrictionTooltip = ({ tooltipTextLines }: DspRestrictionTooltipProps) => {
  return (
    <Tooltip
      title={tooltipTextLines.map((line, index) => (
        <div key={index} style={{ marginTop: index > 0 ? '12px' : '0px' }}>
          {line}
        </div>
      ))}
      placement="right"
      data-test="dsps-seats-tooltip"
    >
      <IconButton size="small">
        <InfoIcon />
      </IconButton>
    </Tooltip>
  );
};
